import React from 'react';
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import "./i18n";
import "@shopify/polaris/build/esm/styles.css";

// Get shop and host from URL params (provided by Shopify when embedding)
const urlParams = new URLSearchParams(window.location.search);
const shopParam = urlParams.get('shop');
const hostParam = urlParams.get('host');

// App Bridge is auto-initialized by the CDN script when shop/host are present.
if (!shopParam && !hostParam) {
    console.warn('Shopify App: Missing shop and host parameters. App Bridge features may be limited.');
}

ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <BrowserRouter
            future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true
            }}
        >
            <Routes>
                <Route path="/*" element={<App />} />
            </Routes>
        </BrowserRouter>
    </React.StrictMode>
);
